<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
    width="50%"
  >
    <div class="content">
      <div class="header">
        <h1 class="title">Add New Phase</h1>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Phase Name*">
            <b-input
              v-model="phaseName"
              required
              placeholder="Enter phase name..."
            />
          </b-field>
        </div>
      </div>

      <div class="report-sections">
        <p class="report-sections-label">Report Sections</p>
        <div class="sections-grid">
          <div class="sections-column">
            <b-checkbox
              v-for="section in firstColumnSections"
              :key="section.key"
              v-model="selectedSections"
              :native-value="section.key"
            >
              {{ section.label }}
            </b-checkbox>
          </div>
          <div class="sections-column">
            <b-checkbox
              v-for="section in secondColumnSections"
              :key="section.key"
              v-model="selectedSections"
              :native-value="section.key"
            >
              {{ section.label }}
            </b-checkbox>
          </div>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { v4 } from 'uuid';
import { REPORT_SECTIONS } from './reportSections';

const uuid = v4;

export default {
  name: 'add-job-phase-modal',

  data() {
    const mid = Math.ceil(REPORT_SECTIONS.length / 2);
    return {
      firstColumnSections: REPORT_SECTIONS.slice(0, mid),
      secondColumnSections: REPORT_SECTIONS.slice(mid),
      phaseName: '',
      selectedSections: REPORT_SECTIONS.map((s) => s.key),
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onSave() {
      if (!this.phaseName || !this.phaseName.trim()) {
        this.$buefy.toast.open({
          message: 'Please enter a phase name.',
          type: 'is-danger',
          duration: 5000,
        });
        return;
      }
      this.$emit('onSave', {
        name: this.phaseName.trim(),
        _id: uuid(),
        reportSections: [...this.selectedSections],
      });
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.report-sections {
  margin-top: 10px;
}

.report-sections-label {
  font-weight: bold;
  margin-bottom: 8px;
}

.sections-grid {
  display: flex;
  gap: 16px;
}

.sections-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
</style>
